import { parseLocaleNumber } from '../components/FormattedNumberInput';

/**
 * @typedef {{
 *   unitNumber: number,
 *   rentPrice?: string | number,
 *   inclusions?: string,
 *   ancillaryRevenue?: string | number,
 *   ancillaryDetails?: string,
 * }} RentRegisterRow
 */

/**
 * @param {RentRegisterRow[] | undefined | null} rentRegister
 * @param {string | number | undefined} numberOfUnits
 * @returns {RentRegisterRow[]}
 */
export function normalizeRentRegister(rentRegister, numberOfUnits) {
  const units = Math.max(0, parseInt(String(numberOfUnits), 10) || 0);
  const existing = Array.isArray(rentRegister) ? rentRegister : [];

  return Array.from({ length: units }, (_, index) => {
    const unitNumber = index + 1;
    const byNumber = existing.find((row) => Number(row?.unitNumber) === unitNumber);
    const byIndex = existing[index];
    const prev = byNumber || byIndex || {};

    return {
      unitNumber,
      rentPrice: prev.rentPrice ?? prev.rent ?? '',
      inclusions: prev.inclusions ?? '',
      ancillaryRevenue: prev.ancillaryRevenue ?? prev.otherServicesPrice ?? '',
      ancillaryDetails: prev.ancillaryDetails ?? prev.otherServicesDetail ?? '',
    };
  });
}

/**
 * @param {RentRegisterRow} row
 * @returns {number}
 */
export function computeRentRegisterRowTotal(row) {
  const rent = Number(parseLocaleNumber(row?.rentPrice)) || 0;
  const ancillary = Number(parseLocaleNumber(row?.ancillaryRevenue)) || 0;
  return rent + ancillary;
}

/**
 * @param {RentRegisterRow[]} rows
 * @returns {number}
 */
export function computeRentRegisterGrandTotal(rows) {
  return (rows || []).reduce((sum, row) => sum + computeRentRegisterRowTotal(row), 0);
}
